import { render, staticRenderFns } from "./detail-content.vue?vue&type=template&id=d25a7fd6&scoped=true"
import script from "./detail-content.vue?vue&type=script&lang=js"
export * from "./detail-content.vue?vue&type=script&lang=js"
import style0 from "./detail-content.vue?vue&type=style&index=0&id=d25a7fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25a7fd6",
  null
  
)

export default component.exports